import type { SVGProps } from 'react'
const SvgSyLocation = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M11.945 1.988c-4.646-.016-8.44 3.755-8.457 8.4v.03l.002.025a10.57 10.57 0 0 0 2.166 6.059l.002.002.002.004a20.6 20.6 0 0 0 5.168 4.846 1.686 1.686 0 0 0 2.176.002 21 21 0 0 0 3.654-3.01l.004-.004c1.967-2.075 3.626-4.77 3.684-7.797v-.102c.014-4.645-3.756-8.439-8.4-8.455m-.004 1.5a6.92 6.92 0 0 1 6.905 6.953v.075c-.047 2.486-1.466 4.887-3.274 6.795a19.4 19.4 0 0 1-3.453 2.841 1 1 0 0 0-.084.063.173.173 0 0 1-.236 0 1 1 0 0 0-.082-.06 19 19 0 0 1-4.86-4.551l-.005-.008a9.1 9.1 0 0 1-1.864-5.201v-.004a6.92 6.92 0 0 1 6.953-6.903"
				clipRule="evenodd"
			/>
			<path
				d="M11.918 7.328a3.22 3.22 0 0 0-3.211 3.211 3.22 3.22 0 0 0 3.211 3.211 3.22 3.22 0 0 0 3.21-3.21 3.22 3.22 0 0 0-3.21-3.212m0 1.5a1.7 1.7 0 0 1 1.71 1.711c0 .954-.756 1.711-1.71 1.711s-1.711-.757-1.711-1.71a1.7 1.7 0 0 1 1.711-1.712"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyLocation
